import Component from './WidgetDesigner';

export default Component;
